<template>
  <b-container class="m-0 p-0">
    <b-row>
      <b-col cols="4"></b-col>
      <b-col class="ns">N: {{ details.N }}</b-col>
    </b-row>
    <b-row>
      <b-col cols="4"></b-col>
      <b-col class="ns">S: {{ details.S }}</b-col>
    </b-row>
    <b-row>
      <b-col cols="4">Round <b>{{ details.Round }}</b></b-col>
      <b-col class="ew">E: {{ details.E }}</b-col>
    </b-row>
    <b-row>
      <b-col cols="4">Tavolo <b>{{ details.Table }}</b></b-col>
      <b-col class="ew">O: {{ details.W }}</b-col>
    </b-row>
    <b-row class="mt-3" v-if="askForOverlay">
      <b-col class="text-right">
        <b-button @click="overlay">Sovrapponi a diagramma</b-button>
      </b-col>
    </b-row>
  </b-container>
  <!--    <b-button size="sm" @click="closeDetails()">Nascondi</b-button>-->
</template>

<script>
import {addColorToSuite as _addColorToSuite} from "../../lib/cardSuits";

export default {
  name: 'ResultDetails',
  props: {
    details: {
      type: Object,
      required: true
    },
    askForOverlay: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    overlay() {
      this.$emit('askedOverlay', this.details);
    },
    addColorToSuite(contract) {
      return _addColorToSuite(contract);
    }
  }
};
</script>

<style scoped>

.ns {
  color: #2661CE;
  font-weight: bold;
}

.ew {
  color: #DC143C;
  font-weight: bold;
}
</style>
